module.exports = __webpack_public_path__ + "static/media/Graphical_abstract-T1D.c8ed055b.jpg";